module.exports = __webpack_public_path__ + "static/img/1085.f382d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1085.jpg
// module id = 267
// module chunks = 0